









































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRef
} from '@nuxtjs/composition-api';

export type FilterCheckboxOptionType = {
  description?: string;
  name?: string;
  answer_option_value?: number | null;
  number_of_products: number;
  _id: number;
  selected: boolean;
  value?: string;
};

export default defineComponent({
  name: 'ExpandableList',
  props: {
    items: {
      type: Array as PropType<FilterCheckboxOptionType[]>,
      default() {
        return [];
      }
    },
    startOpen: {
      type: Boolean,
      default: false
    },
    threshold: {
      type: Number,
      default: 5
    }
  },
  setup(props, context) {
    const isOpen = ref(props.isOpen);

    const itemsProp = toRef(props, 'items');
    const itemsValues = computed(() => {
      return itemsProp.value
        .filter((item) => item.number_of_products !== 0)
        .map((item) => {
          return { ...item, selected: Boolean(item.selected) };
        });
    });
    const toggleAccordion = () => {
      isOpen.value = !isOpen.value;
    };
    const onUpdate = (value, item) => {
      context.emit('updateOption', {
        optionId: item._id,
        selected: !item.selected,
        name: item.description || item.name
      });
    };

    return {
      itemsValues,
      isOpen,
      toggleAccordion,
      onUpdate
    };
  }
});
